import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST, PUT } from "../utils/Methods";

export const Getprofile = createAsyncThunk(
  "profile/get",
  async (_, thunkAPI) => {
    try {
      const res = await GET(APIS.Auth.getprofile, {
        credentials: "include",
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

export const editprofile = createAsyncThunk(
  "masters/editprofile/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Auth.updateprofile}/${id}`, data, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const payload = res?.data?.success !== undefined ? res.data : res;
      if (payload.success) {
        return payload; //
      } else {
        return rejectWithValue(payload);
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllReport = createAsyncThunk(
  "profile/get-all-report",
  async (_, thunkAPI) => {
    try {
      const res = await GET(APIS.Auth.getAllReport, {
        credentials: "include",
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

export const GetAllUserTest = createAsyncThunk(
  "profile/get-all-test",
  async (_, thunkAPI) => {
    try {
      const res = await GET(APIS.Auth.getAllTest, {
        credentials: "include",
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

export const Slice = createSlice({
  name: "contain",
  initialState: {
    getprofile: {},
    updateprofile: {},
    getReportData: {},
    getTestData: [],
    status: null,
    error: null,
  },

  reducers: {
    // ✅ Optimistic update: mark a test attended instantly (no refresh needed)
    markTestAttended: (state, action) => {
      const examId = Number(action.payload);
      if (!examId) return;
      if (!Array.isArray(state.getTestData)) state.getTestData = [];
      const exists = state.getTestData.some(
        (item) => Number(item?.exam_id) === examId
      );
      if (!exists) {
        state.getTestData = [...state.getTestData, { exam_id: examId }];
      }
    },
  },

  extraReducers: (builder) => {
    builder

      // GET PROFILE
      .addCase(Getprofile.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Getprofile.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.getprofile = action.payload || {};
      })
      .addCase(Getprofile.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // UPDATE PROFILE
      .addCase(editprofile.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(editprofile.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.updateprofile = action.payload || {};
      })
      .addCase(editprofile.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllReport.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.getReportData = action.payload || {};
      })
      .addCase(GetAllReport.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllUserTest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUserTest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // ✅ Normalize: API may return [...] or { data: [...] } / { tests: [...] } — always store an array
        const raw = action.payload;
        let arr = Array.isArray(raw)
          ? raw
          : raw?.data ?? raw?.tests ?? raw?.testData ?? [];
        // unwrap one more level: { data: { data: [...] } }
        if (!Array.isArray(arr) && arr && typeof arr === "object") {
          arr = arr?.data ?? arr?.tests ?? [];
        }
        state.getTestData = Array.isArray(arr) ? arr : [];
      })
      .addCase(GetAllUserTest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { markTestAttended } = Slice.actions;

export default Slice.reducer;
